import nopInstance from "../nopInstance.js"

const config = {
    headers: {
    'Content-Type': 'application/json',
    },
};

const getPromotions = async () => {
    const response = await nopInstance.get(`api/promotions`, config);
    return response;
}

export default {
  getPromotions,
};